import axios from "axios";
import { showToast } from "../helpers/show.toast";

function handleErrorResponse(error, toast) {
  const authError = error.response && error.response.status === 401;
  const badReqError = error.response && error.response.status === 400;
  const versionError = error.response && error.response.status === 410;
  const manyReqError = error.response && error.response.status === 429;
  const serverError = error.response && error.response.status === 500;
  const serviceError = error.response && error.response.status === 503;
  const networkError = !error.response;

  //handle authError (401)
  if (authError) {
    localStorage.clear();
    // get localStorage data if needed
    showToast(
      "Session Timeout!",
      "Your session has expired. Please log in again to continue.",
      "error"
    );
    // open login modal if needed
  }

  // handle manyReqError (429)
  if (manyReqError) {
    showToast(
      "Too Many Attempts!",
      "You have made too many requests in a short time. Please try again later.",
      "error"
    );
  }

  // handle serverError (500)
  if (serverError) {
    showToast(
      "Unexpected Error!",
      "Oops! Something went wrong on our server. Please contact support for assistance.",
      "error"
    );
  }

  return Promise.reject(error);
}

function initializeInterceptors(toast, dispatch) {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      return handleErrorResponse(error, toast, dispatch);
    }
  );
}

axios.interceptors.request.use(
  (config) => config,
  (error) => {
    return Promise.reject(error);
  }
);

function setToken(token) {
  let headers = {
    Accept: `application/json`,
    // "user-version": process.env.NEXT_PUBLIC_APP_VERSION,
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  axios.defaults.headers.common = headers;
}

const httpService = {
  setToken,
  get: axios.get,
  put: axios.put,
  post: axios.post,
  patch: axios.patch,
  delete: axios.delete,
  initializeInterceptors,
};

export default httpService;
